import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CheckRegistrationState, checkIfRegisteredFeatureKey } from '../reducers/check-if-registered.reducer';
import * as checkRegistrationReducer from '../reducers/check-if-registered.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, CheckRegistrationState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region CHECK REGISTRASTION SUB STATE
export const getCheckRegistrationState = createSelector(getAuthState, state => state[checkIfRegisteredFeatureKey]);

export const getCheckRegistrationIsLoading = createSelector(
  getCheckRegistrationState,
  checkRegistrationReducer.checkRegisterRequiredRequestLoading
);

//#region CHECK REGISTRASTION
export const getCheckRegistrationRequest = createSelector(
  getCheckRegistrationState,
  checkRegistrationReducer.getCheckRegisterRequiredRequest
);
export const getCheckRegistrationSuccess = createSelector(
  getCheckRegistrationState,
  checkRegistrationReducer.checkRegisterRequiredRequestSuccess
);
export const getCheckRegistrationFailure = createSelector(
  getCheckRegistrationState,
  checkRegistrationReducer.checkRegisterRequiredRequestFailure
);
//#endregion
